<template>
  <div class=" ">
    <div class="p-3 mt-3">
      <div class=" bg-secondary-500 p-2 rounded-t h-32">
        <div class="flex">
          <div class="w-2/3 text-white  text-small font-bold">
            {{ assignment.assignmentName }}
          </div>

          <div class="w-1/3 flex justify-end ">
            <d-btn class="cursor-pointer" :href="'/assignments/' + assignment.id">
              Open
            </d-btn>
          </div>
        </div>
        <div class="flex">
            <p class="w-full text-white text-xs pt-2">
                <strong>Assignee:</strong> {{ assignment.userFullName }}
            </p>
            <p class="w-full text-white text-xs pt-2">
                <strong>Mentor:</strong> {{ assignment.mentorFullName }}
            </p>
        </div>
        
      </div>

      <div class="flex rounded shadow p-3 h-48 bg-white">
        <div class="w-full flex flex-wrap">
          <div v-if="assignment.optional" class="text-s flex text-red-600 font-bold">
            Optional assignment
          </div>
          <div class="flex">
            <div class=" bg-gray-300  rounded-full h-6 w-6 flex items-center justify-center ">
              <d-icon :class="[isCompleted ? 'text-green-500' : 'text-red-500']" :icon="isCompleted ? 'check':'times'"/>
            </div>
            <p v-if="assignment.completedToDosRatio" class="text-black font-bold text-base mb-2 px-2">
              {{ assignment.completedToDosRatio.completed }}/{{ assignment.completedToDosRatio.outOfTotal }} ToDos
              Completed
            </p>
          </div>
          <div class="flex">
            <div class=" bg-gray-300  rounded-full h-6 w-6 flex items-center justify-center ">
              <d-icon :class="[isSubmitted ? 'text-green-500' : 'text-red-500']" :icon="isSubmitted ? 'check':'times'"/>
            </div>
            <p v-if="assignment.submittedToDosRatio" class="text-black text-base mb-2 px-2">
              {{ assignment.submittedToDosRatio.completed }}/{{ assignment.submittedToDosRatio.outOfTotal }} Tasks
              Submitted
            </p>
          </div>
          <div class="flex w-full">
            <p v-if="assignment.completed" class="text-gray-700 text-xs mb-2">
              <span v-if="assignment.latestSubmissionDate">Submission Date: {{
                  assignment.latestSubmissionDate | formatShortDate
                }}</span>
              <br/>
              <span>Completion Date: {{ assignment.completionDate | formatShortDate }}</span>
            </p>
            <p v-else class="text-gray-700 text-xs mb-2">
              <span v-if="assignment.nextTodoItemDueDate">Next Task Due: {{
                  assignment.nextTodoItemDueDate | formatShortDate
                }}</span>
              <span v-else>Next Task Due: N/A</span>
              <br>
              <span>Overall Assignment Due: {{ assignment.assignmentDueDate | formatShortDate }}</span>
              <span v-if="assignment.itemsReadyForReviewCount > 0" class="text-xs text-red-600  mb-2">
              <br>
              {{ assignment.itemsReadyForReviewCount }} tasks ready for review
            </span>
              <br/>
              <span v-if="assignment.latestSubmissionDate">Submission Date: {{
                  assignment.latestSubmissionDate | formatShortDate
                }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    assignment: {
      type: Object,
      default: () => {
      },
    },

  },
  computed: {
    isCompleted() {
      return this.assignment.completedToDosRatio.completed === this.assignment.completedToDosRatio.outOfTotal;
    },
    isSubmitted() {
      return this.assignment.submittedToDosRatio.completed === this.assignment.submittedToDosRatio.outOfTotal;
    },
  },
};
</script>